import {
  GAME_ID,
  SCREENS,
  SET_SCREEN,
} from '../../data/punchlineConstants';

const initialState = { screen: SCREENS.PROGRESS };

const punchlineNavigationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    case SET_SCREEN:
      return {
        ...state,
        screen: action.payload,
      };
    default:
      return state;
  }
};

export default punchlineNavigationReducer;
